import { Component } from '@angular/core';
import { MedrecordIcon } from '../../../base/medrecord-icon';

@Component({
  selector: 'medrecord-bmi',
  templateUrl: './bmi.component.svg',
  styleUrls: [],
})
export class BmiComponent extends MedrecordIcon {
  viewHeight: number = 24;
  viewWidth: number = 24;
}
